import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchDiscountCode } from 'pap/ducks/pricing';
import { showBanner } from 'common/ducks/banner';
import DiscountCode from 'common/components/discount_code';

const mapStateToProps = (_, { params: { codeSlug } }) => {
  return {
    codeSlug,
  };
}

export default withRouter(connect(mapStateToProps, {
  fetch: fetchDiscountCode,
  showBanner,
})(DiscountCode));



// WEBPACK FOOTER //
// ./common/containers/discount_code.jsx